const styles = {
  container: 'w-full md:col-span-6',
  content: 'flex flex-col gap-y-2',

  foot: 'flex flex-row items-center justify-between h-4',

  label: ' !text-base font-bold !text-black',
  description: ' text-xs text-gray-600',
  error: 'text-primary-500 text-xs -translate-y-1 text-right',

  submit: {
    container: 'w-full flex flex-col items-end justify-end mt-8',
    content: 'flex flex-row items-center gap-x-2',

    button:
      '!bg-black text-white cursor-pointer hover:!bg-red-500 !duration-300 !text-base',
    icon: 'text-xs',
  },
};

export default styles;
